import React, { useState } from 'react';
import { Button, Form, FormGroup, Label, Input, Container, ModalHeader, ModalBody, ModalFooter, Row, Col } from 'reactstrap';
import rotas from 'services/rotas';
import rest from 'lib/rest';
import AsyncSelect from 'react-select/async';
import Swal from 'sweetalert2';

const IncluirProduto = ({ onClose, filial_id, sessao_id }) => {

  const initialProduto = {
    produto_id: '',
    produto: '',
    apresentacao: '',    
    prod_saldo:'',
    qtde_pedir:'0'
  }


  const [produto, setProduto] = useState(initialProduto);

  const listarProdutos = (e) =>{
    if(e.length >= 3){
      const url = rotas.pedidoProdutos;

      const retorno = rest.get(url + '?produto=' + e + '&filial_id=' + filial_id);

      let lista = [];

      return retorno.then(ret=>{
        if(ret.success == 'S'){
          ret.lista.map(item=>{
            lista.push({
              id:item.produto_id,
              label:item.produto,
              apresentacao:item.apresentacao,
              prod_saldo:item.prod_saldo
            })
          })

          return(lista);
        }
      })
    }
  }

  const onChange = (e) =>{    
    let prod = {...produto};

    prod.produto_id = e.id;
    prod.produto = e.label;
    prod.apresentacao = e.apresentacao;
    prod.prod_saldo = e.prod_saldo;
    
    setProduto(prod);
  }

  const onChangeQtde = (e) =>{
    let prod = {...produto};

    prod.qtde_pedir = e.target.value;

    setProduto(prod);
  }

  const gravarProduto = () =>{
    let prod = produto;

    prod.filial_id = filial_id;
    prod.sessao_id = sessao_id;

    const url = rotas.pedidoIncluirProduto;

    const parametros = {
      produto:prod
    }

    const retorno = rest.post(url,parametros);

    retorno.then(ret=>{
      if(ret.success == 'S'){
        Swal.fire('Sucesso','Produto Incluído com Sucesso!','success');
        setProduto(initialProduto);
      }else{
        Swal.fire('Erro','Erro ao Incluir o Produto!','error');
      }
    })
  }


  return (
    <>
      <ModalHeader>Incluir Produto</ModalHeader>

      <ModalBody>
        <Row>
          <Col>
            <FormGroup>
              <AsyncSelect 
                cacheOptions 
                defaultOptions 
                //options={listaProdutos}
                loadOptions={listarProdutos}
                onChange={onChange}
                placeholder="Digite o Nome do Produto"
              >
              </AsyncSelect>
              
              {/* <ReactSelect
                name="lojas"
                placeholder="Digite o Nome do Produto"
              //options={lojas}
              //defaultValue= {form.fornecedor}
              //onChange={handleFilial}
              ></ReactSelect> */}
            </FormGroup>
            <FormGroup>
              <Label for="nome">Produto</Label>
              <Input
                type="text"
                name="nome"
                id="nome"
                defaultValue={produto.produto}
                // onChange={handleChange}
                required
              />
            </FormGroup>
            <FormGroup>
              <Label for="apresentacao">Apresentação</Label>
              <Input
                type="text"
                name="apresentacao"
                id="apresentacao"
                defaultValue={produto.apresentacao}
                // onChange={handleChange}
                required
              />
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col>
            <FormGroup>
              <Label for="quantidade">Saldo</Label>
              <Input
                type="number"
                name="quantidade"
                id="quantidade"
                defaultValue={produto.prod_saldo}
                // onChange={handleChange}                
                disabled
              />
            </FormGroup>
          </Col>

          <Col>
            <FormGroup>
              <Label for="quantidade">Quantidade a Pedir</Label>
              <Input
                type="number"
                name="quantidade"
                id="quantidade"
                value={produto.qtde_pedir}
                onChange={onChangeQtde}
                required
              />
            </FormGroup>
          </Col>
        </Row>


      </ModalBody>

      <ModalFooter>
        <Row>
          <Col className="mr-2">
            <Button type="submit" color="success" onClick={gravarProduto} >Gravar</Button>{' '}
            <Button type="button" color="danger" onClick={onClose}>Fechar</Button>
          </Col>
        </Row>
      </ModalFooter>
    </>
  );
};

export default IncluirProduto;